import React from "react";
import {Routes, Route } from "react-router-dom";
// **********************************************************************
import Home from "./Home";
import IpOut from "./components/Pages/IpOut";
import Consultation from "./components/container/Consultation";
import Diagnostic from "./components/container/Diagnostic";
import Sptp from "./components/container/Sptp";
import Branch from "./components/container/Branch";
import Philosophy from "./components/container/Philosophy";
import Learning from "./components/container/Learning";
import Program from "./components/container/Program";
import PROCESS_BASIC from "./components/container/Process_basic";
import PROCESS_GROW from "./components/container/Process_grow";
import PROCESS_MASTER from "./components/container/Process_master";
import PROGRAM_ELEMENTARY1 from "./components/container/Program_elementary1";
import PROGRAM_ELEMENTARY2 from "./components/container/Program_elementary2";
import PROGRAM_ELEMENTARY3 from "./components/container/Program_elementary3";
import PROGRAM_LEARNING from "./components/container/Program_learning";
import PROGRAM_LANGUAGE from "./components/container/Program_language";
import PROGRAM_INQUIRY from "./components/container/Program_inquiry";
import AsobiApp from "./components/Header/AsobiApp";
import Company from "./components/Footer/Company";
import History from "./components/Footer/History";
import Location from "./components/Footer/Location";
import StartUp from "./components/Footer/StartUp";
import Startinfo from "./components/Footer/Startinfo";
import StartProcess from "./components/Footer/StartProcess";
import Benefit from "./components/Footer/Benefit";
import Manager from "./components/Footer/Manager";
import Terms from "./components/Footer/Terms";
import TERMS_V1 from "./components/Footer/Terms_v1";
import Policy from "./components/Footer/Policy";
import POLICY_V3 from "./components/Footer/Policy_v3";
import POLICY_V2 from "./components/Footer/Policy_v2";
import Email from "./components/Footer/Email";
import Customer from "./components/Header/Customer";
import Oneonone from "./components/Header/Oneonone";
import News from "./components/Header/News";
import Event from "./components/Header/Event";
import Social from "./components/Header/Social";
import NewsDetail from "./components/Header/News_detail";
import EventDetail from "./components/Header/Event_detail";
import Presence from "./components/container/Presence";
import PROGRAM_ELEMENTARY from "./components/Main/Program_elementary";
// **********************************************************************
import ProtectedRoute from "./ProtectedRoute";
import ADMIN_LOGIN from "./components/admin/Admin_login";
import ADMIND_INFO from "./components/admin/Admin_Info";
import ADMIND_PERMISSION from "./components/admin/Admin_Permission";
import ADMIN_REGIST from "./components/admin/Admin_regist";
import ADMIN_BANNER from "./components/admin/site/Admin_Banner";
import ADMIN_BVIEW from "./components/admin/site/Admin_Bview";
import ADMIN_BWRITE from "./components/admin/site/Admin_Bwrite";
import ADMIN_POPUP from "./components/admin/site/Admin_Popup";
import ADMIN_PVIEW from "./components/admin/site/Admin_Pview";
import ADMIN_PWRITE from "./components/admin/site/Admin_Pwrite";
import ADMIN_NOTICE from "./components/admin/board/Admin_Notice";
import ADMIN_NVIEW from "./components/admin/board/Admin_Nview";
import ADMIN_NWRITE from "./components/admin/board/Admin_Nwrite";
import ADMIN_EVENT from "./components/admin/board/Admin_Event";
import ADMIN_EWRITE from "./components/admin/board/Admin_Ewrite";
import ADMIN_EVIEW from "./components/admin/board/Admin_Eview";
import ADMIN_SOCIAL from "./components/admin/board/Admin_Social";
import ADMIN_SWRITE from "./components/admin/board/Admin_Swrite";
import ADMIN_SVIEW from "./components/admin/board/Admin_Sview";
import ADMIN_MAGAZINE from "./components/admin/board/Admin_Magazine";
import ADMIN_MVIEW from "./components/admin/board/Admin_Mview";
import ADMIN_MWRITE from "./components/admin/board/Admin_Mwrite";
import ADMIN_ENT from "./components/admin/form/Admin_Ent";
import ADMIN_FR from "./components/admin/form/Admin_Fr";
import ADMIN_JISA from "./components/admin/form/Admin_Jisa";
import ADMIN_Q from "./components/admin/form/Admin_Q";
import ADMIN_ETC_Q from "./components/admin/form/Admin_Ect_q";
import ADMIN_ENTVIEW from "./components/admin/form/Admin_Entview";
import ADMIN_FRVIEW from "./components/admin/form/Admin_Frview";
import ADMIN_JISAVIEW from "./components/admin/form/Admin_Jisaview";
import ADMIN_JISAWRITE from "./components/admin/form/Admin_Jisawrite";
import ADMIN_QVIEW from "./components/admin/form/Admin_Qview";
import ADMIN_ETCQVIEW from "./components/admin/form/Admin_Etcqview";
import ADMIN_SCHEDULE from "./components/admin/form/Admin_Schedule";
import ADMIN_SCHEDULE_WRITE from "./components/admin/form/Admin_Schedul_write";
import ADMIN_SCHEDULE_MAP_UP from "./components/admin/form/Admin_Schedul_map_up";
import ADMIN_SCHEDULE_VIEW from "./components/admin/form/Admin_Schedule_view";
import ADMIN_FRANCHISE from "./components/admin/form/Admin_Franchise";
import ADMIN_FRANCHISE_WRITE from "./components/admin/form/Admin_Franchise_write";
import ADMIN_FRANCHISE_MAP_UP from "./components/admin/form/Admin_Franchise_map_up";
import ADMIN_POINT from "./components/admin/form/Admin_Point";
// **********************************************************************
import ASOBI_BOOKS from "./components/landing/asobi_books";
import ANIMATION_IBOSA from "./components/landing/animation_ibosa";

function App() {
  return (
	<>
	<Routes>
	  <Route path="/" element={<Home />} />
	  <Route path="/ip_out" element={<IpOut />} />
	  <Route path="/consultation" element={<Consultation />} />
	  <Route path="/diagnostic" element={<Diagnostic />} />
	  <Route path="/sptp" element={<Sptp />} />
	  <Route path="/branch" element={<Branch />} />
	  <Route path="/philosophy" element={<Philosophy />} />
	  <Route path="/learning" element={<Learning />} />
	  <Route path="/program" element={<Program />} />
	  <Route path="/process_basic" element={<PROCESS_BASIC />} />
	  <Route path="/process_grow" element={<PROCESS_GROW />} />
	  <Route path="/process_master" element={<PROCESS_MASTER />} />
	  <Route path="/program_elementary1" element={<PROGRAM_ELEMENTARY1 />} />
	  <Route path="/program_elementary2" element={<PROGRAM_ELEMENTARY2 />} />
	  <Route path="/program_elementary3" element={<PROGRAM_ELEMENTARY3 />} />
	  <Route path="/program_learning" element={<PROGRAM_LEARNING />} />
	  <Route path="/program_language" element={<PROGRAM_LANGUAGE />} />
	  <Route path="/program_inquiry" element={<PROGRAM_INQUIRY />} />
	  <Route path="/app" element={<AsobiApp />} />
	  <Route path="/company" element={<Company />} />
	  <Route path="/history" element={<History />} />
	  <Route path="/location" element={<Location />} />
	  <Route path="/startUp" element={<StartUp />} />
	  <Route path="/startInfo" element={<Startinfo />} />
	  <Route path="/startProcess" element={<StartProcess />} />
	  <Route path="/benefit" element={<Benefit />} />
	  <Route path="/asobimanager" element={<Manager />} />
	  <Route path="/terms" element={<Terms />} />
	  <Route path="/terms_v1" element={<TERMS_V1 />} />
	  <Route path="/policy" element={<Policy />} />
	  <Route path="/policy_v3" element={<POLICY_V3 />} />
	  <Route path="/policy_v2" element={<POLICY_V2 />} />
	  <Route path="/email" element={<Email />} />
	  <Route path="/customer" element={<Customer />} />
	  <Route path="/oneonone" element={<Oneonone />} />
	  <Route path="/news" element={<News />} />
	  <Route path="/news_detail/:idx" element={<NewsDetail />} />
	  <Route path="/event" element={<Event />} />
	  <Route path="/event_detail/:idx" element={<EventDetail />} />
	  <Route path="/social" element={<Social />} />
	  <Route path="/presence" element={<Presence />} />
	  <Route path="/program_elementary" element={<PROGRAM_ELEMENTARY />} />
	  
	  {/* *********************** landing **************************** */}
	  <Route path="/landing/asobi_books" element={<ASOBI_BOOKS />} />
	  <Route path="/landing/animation_ibosa" element={<ANIMATION_IBOSA />} />

	  {/* *********************** admin **************************** */}
	  <Route path="/admin/admin_login" element={<ADMIN_LOGIN />} />
	  <Route path="/admin/admin_regist" element={<ADMIN_REGIST />} />
	  <Route element={<ProtectedRoute />}>
	    <Route path="/admin/admin_info" element={<ADMIND_INFO />} />
		<Route path="/admin/admin_permission" element={<ADMIND_PERMISSION />} />
	    <Route path="/admin/site/banner" element={<ADMIN_BANNER />} />
	    <Route path="/admin/site/Bview/:idx" element={<ADMIN_BVIEW />} />
	    <Route path="/admin/site/Bwrite" element={<ADMIN_BWRITE />} />
	    <Route path="/admin/site/popup" element={<ADMIN_POPUP />} />
	    <Route path="/admin/site/Pview/:idx" element={<ADMIN_PVIEW />} />
	    <Route path="/admin/site/Pwrite" element={<ADMIN_PWRITE />} />
	    <Route path="/admin/board/notice" element={<ADMIN_NOTICE />} />
	    <Route path="/admin/board/Nview/:idx" element={<ADMIN_NVIEW />} />
	    <Route path="/admin/board/Nwrite" element={<ADMIN_NWRITE />} />
	    <Route path="/admin/board/event" element={<ADMIN_EVENT />} />
	    <Route path="/admin/board/Ewrite" element={<ADMIN_EWRITE />} />
	    <Route path="/admin/board/Eview/:idx" element={<ADMIN_EVIEW />} />
	    <Route path="/admin/board/social" element={<ADMIN_SOCIAL />} />
	    <Route path="/admin/board/Swrite" element={<ADMIN_SWRITE />} />
	    <Route path="/admin/board/Sview/:idx" element={<ADMIN_SVIEW />} />
	    <Route path="/admin/board/magazine" element={<ADMIN_MAGAZINE />} />
	    <Route path="/admin/board/Mview/:idx" element={<ADMIN_MVIEW />} />
	    <Route path="/admin/board/Mwrite" element={<ADMIN_MWRITE />} />
	    <Route path="/admin/form/ent" element={<ADMIN_ENT />} />
	    <Route path="/admin/form/entview/:idx" element={<ADMIN_ENTVIEW />} />
	    <Route path="/admin/form/fr" element={<ADMIN_FR />} />
	    <Route path="/admin/form/frview/:idx" element={<ADMIN_FRVIEW />} />
	    <Route path="/admin/form/jisa" element={<ADMIN_JISA />} />
	    <Route path="/admin/form/jisaview/:idx" element={<ADMIN_JISAVIEW />} />
	    <Route path="/admin/form/jisawrite" element={<ADMIN_JISAWRITE />} />
	    <Route path="/admin/form/q" element={<ADMIN_Q />} />
	    <Route path="/admin/form/qview/:idx" element={<ADMIN_QVIEW />} />
	    <Route path="/admin/form/etc_q" element={<ADMIN_ETC_Q />} />
	    <Route path="/admin/form/etcqview/:idx" element={<ADMIN_ETCQVIEW />} />
	    <Route path="/admin/form/schedule" element={<ADMIN_SCHEDULE />} />
	    <Route
	      path="/admin/form/schedule_map_up"
	      element={<ADMIN_SCHEDULE_MAP_UP />}
	    />
	    <Route
	      path="/admin/form/schedule_write"
	      element={<ADMIN_SCHEDULE_WRITE />}
	    />
	    <Route
	      path="/admin/form/schedule_view/:matchCode"
	      element={<ADMIN_SCHEDULE_VIEW />}
	    />
	    <Route path="/admin/form/franchise" element={<ADMIN_FRANCHISE />} />
	    <Route
	      path="/admin/form/franchise_write"
	      element={<ADMIN_FRANCHISE_WRITE />}
	    />
	    <Route
	      path="/admin/form/franchise_map_up"
	      element={<ADMIN_FRANCHISE_MAP_UP />}
	    />
	    <Route path="/admin/form/point" element={<ADMIN_POINT />} />
	  </Route>
	</Routes>
	</>
  );
}

export default App;
